import {ARRAY_ERROR} from 'final-form'
import type {Schedule} from '../types/domain'

type RowErrors = Record<string, string | undefined>
type BlindErrors = RowErrors[] & {[ARRAY_ERROR]?: string}

const integerAtLeast = (value: number, minimum: number) => Number.isInteger(value) && value >= minimum
const numericError = (value: number, minimum: number) => integerAtLeast(value, minimum) ? undefined : `Enter a whole number of at least ${minimum}.`
const rowErrors = (rows: RowErrors[]) => rows.some(row => Object.values(row).some(Boolean)) ? rows : undefined

export function scheduleNumericErrors(schedule: Schedule) {
  const blinds: BlindErrors = schedule.blinds.map(blind => ({
    smallBlind: numericError(blind.smallBlind, 1),
    bigBlind: integerAtLeast(blind.bigBlind, blind.smallBlind) ? undefined : 'Enter a whole number at least as large as the small blind.',
    ante: numericError(blind.ante ?? 0, 0),
  }))
  if (schedule.blinds.length < 2) blinds[ARRAY_ERROR] = 'Include at least two blind levels.'
  return {
    levelLength: numericError(schedule.levelLength, 1),
    blinds: blinds[ARRAY_ERROR] || rowErrors(blinds) ? blinds : undefined,
    breaks: rowErrors(schedule.breaks.map(segment => ({length: numericError(segment.length, 1)}))),
    chips: rowErrors(schedule.chips.map(chip => ({value: numericError(chip.value, 1)}))),
  }
}

export const hasNumericScheduleErrors = (schedule: Schedule) => Object.values(scheduleNumericErrors(schedule)).some(Boolean)
